module.exports = __webpack_public_path__ + "static/media/rino-map.3c5d013c.jpg";